import { all, call, put, retry, select, takeLatest } from 'redux-saga/effects';

import { mainActions, mainSelector } from '$store/main/index';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { batchActions } from '$store';
import { postsActions } from '$store/posts';
import { initWorker } from '$store/auth/sagas';
import {
  EditIncognitoEnabledAction,
  SetFeatureAsShownAction,
} from '$store/main/interface';
import { setStorageItem } from '$utils';
import { goBack } from '$navigation/helper';

function* loadMainPageDataWorker() {
  try {
    const data = yield retry(Infinity, 3000, Api.get, '/main/page');
    yield put(
      batchActions(
        mainActions.setGroups(data.groups),
        postsActions.setPosts(data.posts),
        mainActions.setMainPageData({
          groups: Object.keys(data.groups).map((item) => +item),
          posts: data.posts.map((item) => item.id),
        }),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* checkConnectionWorker() {
  yield retry(Infinity, 3000, Api.post, '/rates');
  yield initWorker();
  yield put(mainActions.setOffline(false));
}

function* setFeatureAsShownWorker(action: SetFeatureAsShownAction) {
  try {
    yield put(toastActions.setToastLoading());
    yield call(Api.post, '/profile/seen_feature', {
      feature: action.payload,
    });
    const { showFeatures } = yield select(mainSelector);
    yield put(
      batchActions(
        mainActions.setShowFeatures({
          ...showFeatures,
          [action.payload]: false,
        }),
        toastActions.hideToast(),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* editIncognitoEnabledWorker(action: EditIncognitoEnabledAction) {
  try {
    // FIXME: maybe get user and full refresh main state
    const data = yield call(Api.post, '/profile/incognito', {
      enabled: action.payload,
    });

    if (!data.user) {
      yield put(toastActions.setToastFail());
    } else {
      yield put(
        batchActions(
          mainActions.setIncognitoEnabled(data.user.incognito),
          toastActions.setToastSuccess(),
        ),
      );
      goBack();
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* setAgePopoverHiddenWorker() {
  yield call(setStorageItem, 'agePopoverHidden', 'true');
}

export function* mainSaga() {
  yield all([
    takeLatest(mainActions.loadMainPageData, loadMainPageDataWorker),
    takeLatest(mainActions.checkConnection, checkConnectionWorker),
    takeLatest(mainActions.setFeatureAsShown, setFeatureAsShownWorker),
    takeLatest(mainActions.setAgePopoverHidden, setAgePopoverHiddenWorker),
    takeLatest(mainActions.editIncognitoEnabled, editIncognitoEnabledWorker),
  ]);
}
